
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeature,
  CharacterFeatureBase,
  FightingStyle 
} from "@dndModels";

export class CharacterFightingStyle extends CharacterFeatureSource {
  source: FightingStyle | null = null;
  source_source_id = "";
  source_name = "";
  source_type = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (obj.fighting_style_id) {
        this.source_id = obj.fighting_style_id;
        this.source_source_id = obj.source_id;
      } else {
        this.source_source_id = obj.source_source_id ? obj.source_source_id : "";
      }
      this.source_name = obj.source_name ? obj.source_name : "";
      this.source_type = obj.source_type ? obj.source_type : "";
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        const char_features: CharacterFeature[] = [];
        obj.features.forEach((o: any) => {
          char_features.push(new CharacterFeature(o));
        });
        const char_feature_base = new CharacterFeatureBase();
        char_feature_base.features = char_features;
        this.char_feature_bases.push(char_feature_base);
      }
    }
    // this.id = obj ? obj.id : 0;
    // this.source_id = obj ? obj.fighting_style_id : "";
    // this.char_feature_bases = [];
    // if (obj && obj.features && obj.features.length > 0) {
    //   obj.features.forEach((o: any) => {
    //     this.char_feature_bases.push(new CharacterFeature(o));
    //   });
    // }
    // this.source_source_id = obj && obj.source_id ? obj.source_id : "";
    // this.source_name = obj && obj.source_name ? obj.source_name : "";
    // this.source_type = obj && obj.source_type ? obj.source_type : "";
    // // this.level = obj ? obj.level : 0;
    // this.source = obj && obj.fighting_style ? new FightingStyle(obj.fighting_style) : null;
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      source_source_id: this.source_source_id,
      source_name: this.source_name,
      source_type: this.source_type
    };
  }

  clone(drop_ids = false): CharacterFightingStyle {
    const clone = new CharacterFightingStyle();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterFightingStyle, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source?.clone()??null;
    this.source_source_id = copyMe.source_source_id;
    this.source_name = copyMe.source_name;
    this.source_type = copyMe.source_type;
  }
}